import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { UserService } from '../../../core/services/user.service';
import { ToastService } from '../../services/toast.service';
import { User } from '../../models';
import { UserDropdownComponent } from '../../components/user-dropdown/user-dropdown';
import { UserProfileComponent } from '../../components/user-profile/user-profile';
import { PluginHeaderNavComponent } from '../../components/plugin-header-nav/plugin-header-nav';

import { Dialog } from '@openng/optimus-ui/dialog';

@Component({
  selector: 'app-plugin-layout',
  imports: [RouterModule, UserDropdownComponent, UserProfileComponent, PluginHeaderNavComponent, Dialog],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './plugin-layout.html',

})
export class PluginLayoutComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  currentUser: User | null = null;
  showProfileModal = false;

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        // Notify plugin about logout
        this.notifyPlugin('LOGOUT');
        
        // Navigate to plugin login instead of main login
        this.router.navigate(['/plugin/login']);
      },
      error: () => {
        // Even if logout fails, redirect to plugin login
        this.router.navigate(['/plugin/login']);
      }
    });
  }

  private notifyPlugin(message: string) {
    try {
      // Check if we're running inside WebView2
      if ((window as any).angulerisPlugin) {
        (window as any).angulerisPlugin.sendMessage(message);
      }
    } catch (error) {
      console.warn('Plugin communication not available:', error);
    }
  }

  openProfile(): void {
    this.showProfileModal = true;
  }

  closeProfile(): void {
    this.showProfileModal = false;
  }

  saveProfile(): void {
    // Profile saving is now handled internally by the UserProfileComponent
    this.closeProfile();
  }
}